import { useEffect, useState } from "react";
import { Button, Card, Divider, Form, Input, Spin, InputNumber, message, Select, Switch, Modal } from "antd";
import styles from "../styles/Params.module.css";
import cx from "classnames";


const { Option } = Select;

const ParamsUi = (props) => {
  const { loading, listparams, listbinpromos, sendParams } = props;
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({});
  const [paramStatus, setParamStatus] = useState({});
  // Convertimos el array en initialValues para el formulario

  useEffect(() => {
    if (listparams && listparams.length > 0) {
      const initialValues = listparams.reduce((acc, curr) => {
        let isBoolean = false;
        const listboolean = ['app_guest_enable', 'app_guest_usecode','app_delivery_peya_enable','app_delivery_peya_enable','app_delivery_floti_enable','app_delivery_selft_enable','app_delivery_peya_test','app_checkout_promotion_cards','app_user_can_viewfavs','app_user_order_history_reorder','app_order_auto_finish','']
        if(listboolean.includes(curr.name)) {
          isBoolean = true;
        }
        acc[curr.name] = isBoolean?curr.value === "1":curr.value;
        if(curr.name === 'app_driverpause_admin_notifications' || curr.name === 'app_driver_reporterror_notifications' || curr.name === 'app_checkout_promolist_cards') {
          acc[curr.name] = curr.value.split(",");
        }
        if(curr.name === 'app_survey_notification_delay') {
          acc[curr.name] = curr.value / 60 / 1000;
        }
        return acc;
      }, {});
      
      // Crear un objeto con el status de cada parámetro
      const statusObj = listparams.reduce((acc, curr) => {
        acc[curr.name] = curr.status === 1;
        return acc;
      }, {});
      
      setFormValues(initialValues);
      setParamStatus(statusObj);
      form.setFieldsValue(initialValues);
    }
  }, [listparams, form]);

  // Función para actualizar el estado cuando cambian los valores del formulario
  const handleFormValuesChange = (changedValues, allValues) => {
    setFormValues(allValues);
  };

  const handleSubmit = (values) => {
    try {
      Modal.confirm({
        title: 'Confirmar guardado',
        content: '¿Estás seguro de que deseas guardar los cambios en la configuración?',
        okText: 'Sí, guardar',
        cancelText: 'Cancelar',
        onOk: () => {
          form
            .validateFields()
            .then((values) => {
              const formatted = {
                ...values,
                app_survey_notification_delay: (values.app_survey_notification_delay * 60 * 1000),
                app_checkout_promolist_cards: values.app_checkout_promolist_cards?.join(',') || '',
                app_driverpause_admin_notifications: values.app_driverpause_admin_notifications?.join(',') || '',
                app_driver_reporterror_notifications: values.app_driver_reporterror_notifications?.join(',') || ''
              };
              console.log('Formulario formateado para envío:', formatted);
              sendParams(formatted);
            })
            .catch((err) => {
              message.error('Revisa los campos del formulario');
              console.error(err);
            });
        }
      });
    } catch (error) {
      console.error(error);
      message.error("Hubo un error al guardar los cambios");
    }
  };

  return (
    <div className={styles.wrapper}>
      <Form 
        form={form} 
        onFinish={handleSubmit} 
        layout="vertical"
        onValuesChange={handleFormValuesChange}
      >
        {!loading ? (
          <Card>
            <Divider orientation="left">General</Divider>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {paramStatus.app_currency_symbol && (
                <div>
                  <Form.Item
                    key="app_currency_symbol"
                    name="app_currency_symbol"
                    label={<p className="font-medium">Símbolo Moneda</p>}
                    valuePropName="value"
                  >
                    <Input placeholder="$" />
                  </Form.Item>
                </div>
              )}
              {paramStatus.app_currency_iso && (
              <div>
              <Form.Item
                key="app_currency_iso"
                name="app_currency_iso"
                label={<p className="font-medium">Código ISO Moneda</p>}
                valuePropName="value"
              >
                <Input placeholder="USD" />
              </Form.Item>
              </div>
              )}
              {paramStatus.IVA && (
              <div>
                <Form.Item
                  key="IVA"
                  name="IVA"
                  label={<p className="font-medium">IVA</p>}
                  valuePropName="value"
                >
                  <Input placeholder="0.00" addonBefore={formValues.app_currency_symbol} />
                </Form.Item>
              </div>
              )}
              {/* 
              {paramStatus.app_order_history_perpage && (
              <div>
              <Form.Item
                  key="app_order_history_perpage"
                  name="app_order_history_perpage"
                  label={<p className="font-medium">Historial: Ordenes por Pagina</p>}
                  valuePropName="value"
                >
                    <InputNumber placeholder="1" />
                </Form.Item>
              </div>
              )}
              
              {paramStatus.app_survey_notification_delay && (
              <div>
              <Form.Item
                  key="app_survey_notification_delay"
                  name="app_survey_notification_delay"
                  label={<p className="font-medium">Encuesta: Tiempo de espera para enviar notificacion</p>}
                  valuePropName="value"
                  
                >
                    <InputNumber placeholder="3" addonAfter="minutos" />
                </Form.Item>
              </div>
              )}
              */}
            </div>

            <Divider orientation="left">Checkout</Divider>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {paramStatus.app_checkout_promotion_cards && (
              <div>
                <Form.Item
                  key="app_checkout_promotion_cards"
                  name="app_checkout_promotion_cards"
                  label={<p className="font-medium">Activar Promociones en Tarjeta</p>}
                  valuePropName="checked"
                >
                  <Switch className="mt-2" />
                </Form.Item>
              </div>
            )}
            {/* 
             {paramStatus.app_order_minimun && (
              <div>
                <Form.Item
                  key="app_order_minimun"
                  name="app_order_minimun"
                  label={<p className="font-medium">Mínimo de Compra Delivery</p>}
                  valuePropName="value"
                >
                  <Input placeholder="0.00" addonBefore={formValues.app_currency_symbol} />
                </Form.Item>
              </div>
             )}
              */}
             {paramStatus.app_checkout_promotion_cards && (
              <div>
              <Form.Item
                  key="app_checkout_promolist_cards"
                  name="app_checkout_promolist_cards"
                  label={<p className="font-medium">Promociones activas de Tarjeta</p>}
                >
                    <Select 
                      mode="multiple" 
                      placeholder="Selecciona promociones"
                      tokenSeparators={[',']}
                      options={listbinpromos.map((promo) => ({
                        label: promo.name, 
                        value: promo.id 
                      }))}
                    />
                </Form.Item>            
              </div>
              )}
            </div>
            {/* 
            {(paramStatus.app_guest_enable && paramStatus.app_guest_usecode)  && (
              <>
              <Divider orientation="left">Usuario Invitado</Divider>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Form.Item
                    key="app_guest_enable"
                    name="app_guest_enable"
                    label={<p className="font-medium">Permitir finalizar comprar</p>}
                    valuePropName="checked"
                  >
                    <Switch className="mt-2" />
                  </Form.Item>
                </div>
                <div>
                  <Form.Item
                    key="app_guest_usecode"
                    name="app_guest_usecode"
                    label={<p className="font-medium">Permitir ingresar código descuento</p>}
                    valuePropName="checked"
                  >
                    <Switch className="mt-2" />
                  </Form.Item>
                </div>
              </div>
              </>
            )}
            */}
            <Divider orientation="left">Delivery</Divider>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
               {/* 
              <div>
                <Form.Item
                  key="app_delivery_floti_enable"
                  name="app_delivery_floti_enable"
                  label={<p className="font-medium">Envío por Floti</p>}
                  valuePropName="checked"
                >
                  <Switch className="mt-2" />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  key="app_delivery_peya_enable"
                  name="app_delivery_peya_enable"
                  label={<p className="font-medium">Envío por PedidosYa Courier</p>}
                  valuePropName="checked"
                >
                  <Switch className="mt-2" />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  key="app_delivery_selft_enable"
                  name="app_delivery_selft_enable"
                  label={<p className="font-medium">Envío propio</p>}
                  valuePropName="checked"
                >
                  <Switch className="mt-2" />
                </Form.Item>
              </div>
             
              <div>
                <Form.Item
                  key="app_driver_method_finish"
                  name="app_driver_method_finish"
                  label={<p className="font-medium">Driver Método finalización de orden</p>}
                >
                  <Select >
                    <Option value="">Selecciona Método</Option>
                    <Option value="WITH_IMAGE">Por medio de Imagen</Option>
                    <Option value="WITH_CODE">Por medio de Código</Option>
                  </Select>
                </Form.Item>
              </div>
              <div>
              <Form.Item
                  key="app_driverpause_admin_notifications"
                  name="app_driverpause_admin_notifications"
                  label={<p className="font-medium">Notificación driver pausa</p>}
                >
                  <Select
                      mode="tags"
                      style={{ width: '100%' }}
                      tokenSeparators={[',']}
                    />
                </Form.Item>
              </div>
              <div>
              <Form.Item
                  key="app_driver_reporterror_notifications"
                  name="app_driver_reporterror_notifications"
                  label={<p className="font-medium">Notificación error app driver</p>}
                >
                  <Select
                      mode="tags"
                      style={{ width: '100%' }}
                      tokenSeparators={[',']}
                    />
                </Form.Item>
              </div>
              */}
            </div>
            { formValues.app_delivery_selft_enable && <>
              <Divider orientation="left">Opciones Envío Propio</Divider>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Form.Item
                    key="store_driver_radius"
                    name="store_driver_radius"
                    label={<p className="font-medium">Radio de distancia para notificación de Tienda</p>}
                    valuePropName="value"
                  >
                    <InputNumber placeholder="$" addonAfter="m" />
                  </Form.Item>
                </div>
              </div>
            </> }
            
            { formValues.app_delivery_peya_enable && <>
              <Divider orientation="left">Opciones Envío PedidosYa Courier</Divider>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Form.Item
                    key="app_delivery_peya_test"
                    name="app_delivery_peya_test"
                    label={<p className="font-medium">Modo prueba</p>}
                    valuePropName="checked"
                  >
                      <Switch className="mt-2" />
                  </Form.Item>
                </div>
                <div>
                <Form.Item
                  key="app_delivery_peya_maxamount"
                  name="app_delivery_peya_maxamount"
                  label={<p className="font-medium">Monto Máximo permitido</p>}
                  valuePropName="value"
                >
                  <Input placeholder="0.00" />
                </Form.Item>
                </div>
              </div>
            </>}
            
            <Divider orientation="left">Otros</Divider>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* 
              <div>
                <Form.Item
                  key="app_user_can_viewfavs"
                  name="app_user_can_viewfavs"
                  label={<p className="font-medium">Usuarios pueden ver favoritos</p>}
                  valuePropName="checked"
                >
                    <Switch className="mt-2" />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  key="app_user_order_history_reorder"
                  name="app_user_order_history_reorder"
                  label={<p className="font-medium">Usuarios pueden reordenar</p>}
                  valuePropName="checked"
                >
                    <Switch className="mt-2" />
                </Form.Item>
              </div>
              */}
              <div>
                <Form.Item
                  key="app_order_auto_finish"
                  name="app_order_auto_finish"
                  label={<p className="font-medium">Orden se auto-finaliza</p>}
                  valuePropName="checked"
                >
                    <Switch className="mt-2" />
                </Form.Item>
              </div>
            </div>
            
            <Divider orientation="left">Integraciones</Divider>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
              <p className="font-medium">Imágenes Cloudflare</p>
              <Form.Item
                  key="images_cloudflare_accountID"
                  name="images_cloudflare_accountID"
                >
                    <Input placeholder="Account ID" />
                </Form.Item>
                <Form.Item
                  key="images_cloudflare_apiKey"
                  name="images_cloudflare_apiKey"
                >
                    <Input placeholder="API Key" />
                </Form.Item>
              </div>
              <div>
              <p className="font-medium">UBER</p>
              <Form.Item
                  key="integrator_uber_token"
                  name="integrator_uber_token"
                >
                    <Input placeholder="Token" />
                </Form.Item>
              </div>
            </div>

            <Button type="primary" className="mt-6 w-full md:w-auto" htmlType="submit">
              Guardar Cambios
            </Button>
          </Card>
        ) : (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
        )}
      </Form>
    </div>
  );
};

export default ParamsUi;
